import axiosInstance from './axiosConfig'

// GET - Fetch data
export const get = async (url, authRequired = false, version = null) => {
  const response = await axiosInstance.get(url, {
    authRequired,
    version
  })
  return response.data
}

// POST - Create data
export const post = async (url, data, authRequired = false, version = null) => {
  const response = await axiosInstance.post(url, data, {
    authRequired,
    version,
  })
  return response.data
}

// PUT - Update data
export const put = async (url, data, authRequired = false, version = null) => {
  const response = await axiosInstance.put(url, data, { authRequired, version })
  return response.data
}

// DELETE - Remove data
export const del = async (url, authRequired = false, version = null) => {
  const response = await axiosInstance.delete(url, { authRequired, version })
  return response.data
}
